<template>
    <div>
        <component @hideAll="hideAll" :is="version"></component>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const getters = [
    'is_collapsed',
];
const actions = [
    'getClient',
];

export default {
    name: 'Main',
    methods: {
        ...mapActions(actions),
        hideAll(){
            this.$emit('hideAll');
        },
    },
    computed: {
        ...mapGetters(getters),
        version() {
            return this.is_collapsed ? 'MobileMain' : 'DesktopMain';
        },
    },
    components: {
        MobileMain: () => import('../components/main/MobileMain'),
        DesktopMain: () => import('../components/main/DesktopMain'),
    },
    async mounted() {
        if(this.clientId != undefined){
            this.getClient(this.clientId);
        }
    },
    data(){
        return{
            clientId: this.$route.params.id,
        };
    },
};
</script>
